import { createApp } from 'vue'
import AppProductSelector from './apps/product-selector/App.vue'
import AppProductSelectorV2 from './apps/product-selector-v2/App.vue'
import AppProductConfigurator from './apps/product-configurator-combinations/App.vue'
import AppProductImages from './apps/product-images/App.vue'
import AppCartSummary from './apps/cart-summary/App.vue'
import AppCartSummaryV2 from './apps/cart-summary-v2/App.vue'
import AppCartSummaryDiscoverMode from './apps/cart-summary-discovermode/App.vue'
import AppCheckoutCartDiscoverMode from './apps/checkout-cart-discovermode/App.vue'
import AppCheckout from './apps/checkout/App.vue'
import AppProductAwards from './apps/product-awards/App.vue'
import AppMessageBar from './apps/message-bar/App.vue'
import vueStore from './store/store.js'

window.vueStore = vueStore

//import BootstrapVue3 from 'bootstrap-vue-3'

createApp(AppProductSelector)
    .mount("#vue-product-selector");

createApp(AppProductSelectorV2)
    .mount("#vue-product-selector-v2");

createApp(AppProductConfigurator)
    .mount("#vue-product-configurator-combinations");

createApp(AppProductImages)
    .mount("#vue-product-images");

createApp(AppCartSummary)
    .mount("#vue-cart-summary");

createApp(AppCartSummaryV2)
    .mount("#vue-cart-summary-v2");

createApp(AppCartSummaryDiscoverMode)
    .mount("#vue-cart-summary-discovermode");

document.querySelectorAll('.vue-checkout-cart-discovermode').forEach(function (el) {
    createApp(AppCheckoutCartDiscoverMode).mount(el);
});

//bootstrap uitgezet, omdat in test mode icm vue 2 modal windows niet werden getoond (loqate address validation) en eerste carrousel niet werd ingeklapt
//createApp(AppCheckout).use(BootstrapVue3)
//    .mount("#vue-checkout");

createApp(AppCheckout)
    .mount("#vue-checkout");

createApp(AppProductAwards)
    .mount("#vue-product-awards");


createApp(AppMessageBar)
    .mount("#vue-message-bar");
     